import * as React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {ExtendedWrappedFieldProps} from '../FormFields';
import * as _ from 'lodash';

const FormCheckbox: React.FunctionComponent<ExtendedWrappedFieldProps> = ({
  meta,
  showErrors,
  input: {value, ...otherInput},
  label,
  ...props
}) => {
  return (
    <FormControlLabel
      label={label}
      {..._.omit(props, 'fullWidth')}
      control={<Checkbox checked={value} {...otherInput} />}
    />
  );
};

export default FormCheckbox;
